module.exports = __webpack_public_path__ + "img/logo-shadow.521f48a1.png";